import { ContractTemplateApi } from "../api"
import Helper from "../plugins/Helper/Helper"
import moment from "moment"
import i18n from '@/plugins/vue-i18n';
export class ContractTemplate {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async getContractTemplates(projectId) {
    const { data } = await ContractTemplateApi.getContractTemplates(projectId);
    return data.result.map((item) => (item = new ContractTemplate(item)));
  }
  static async createContractTemplate(formData) {
    const { data } = await ContractTemplateApi.createContractTemplate(formData);
    return new ContractTemplate(data.result)
  }
  static async editContractTemplate(formData) {
    const { data } = await ContractTemplateApi.editContractTemplate(formData);
    return new ContractTemplate(data.result)
  }
  static async removeContractTemplate(id) {
    const { data } = await ContractTemplateApi.removeContractTemplate(id);
    return data
  }
  static prepareObjectData({
    project,
    market,
    contract,
    customer,
    billingSettings,
    areaAccountingProducts,
    contractSuspend,
    areaInterest,
    contractCheckout,
    user
  }) {
    let data = {}
    data.date = moment().format("D/MM/") + (moment().year() + 543)
    data.fullDate = moment().format("D MMMM ") + (moment().year() + 543)

    if (project) {
      data.proName = project.name || ""
    }
    if (market) {
      data.marName = market.name || ""
    }
    if (user) {
      data.createdBy = `${user.firstName} ${user.lastName}`
    }
    if (contract) {
      data.conId = contract.contractId || ""
      data.conBusinessName = contract.businessName || ""
      data.conSFullDate = contract.startDate && contract.startDate.iso
        ? moment(contract.startDate.iso).format("D MMMM ") + (moment(contract.startDate.iso).year() + 543)
        : ""
      data.conEFullDate = contract.endDate && contract.endDate.iso
        ? moment(contract.endDate.iso).format("D MMMM ") + (moment(contract.endDate.iso).year() + 543)
        : ""
      data.conLenNum = contract.startDate && contract.startDate.iso && contract.endDate && contract.endDate.iso
        ? moment(contract.endDate.iso).diff(contract.startDate.iso, 'months')
        : ""
      data.conLenNumText = Helper.numberToText(data.conLenNum)
      data.conLenDNum = contract.startDate && contract.startDate.iso && contract.endDate && contract.endDate.iso
        ? Math.round(moment(contract.endDate.iso).diff(contract.startDate.iso, 'days', true))
        : ""
      data.conLenDNumText = Helper.numberToText(data.conLenDNum)

      data.conLenYNum = contract.startDate && contract.startDate.iso && contract.endDate && contract.endDate.iso
        ? Helper.dayMonthYearText(contract.startDate.iso, contract.endDate.iso)
        : ""
      data.conType = contract.stallType == "regularly" ? i18n.t('contact.stall_type.regularly') : contract.stallType == "temporary" ? i18n.t('contact.stall_type.temporary') : ""
      data.conAreaSize = 0
      data.conAreas = "-"
      data.conAreaLen = 0
      data.conProducts = "-"
      data.conCategory = '-'
      data.conAddress = '-'
      if (contract.billingData) {
        data.conAddress = contract.billingData.address || '-'
      }
      if (contract.areas && contract.areas.length) {
        let areas = contract.areas
        data.conAreaSize = areas.reduce((a, b) => a + (b.size || 0), 0)
        data.conAreaSizeText = Helper.numberToText(data.conAreaSize)
        data.conAreas = areas.map(d => d.name).join(",")
        data.conAreaLen = areas.length
        data.conAreaLenText = Helper.numberToText(data.conAreaLen)
        let products = []
        let category = []
        for (let area of areas) {
          if (area.products && area.products.length) {
            for (let product of area.products) {
              products.push(product.name)
              if (product.productCategory) {
                category.push(product.productCategory.name)
              }
            }
          }
        }
        data.conProducts = [...new Set(products)].join(",") || "-";
        data.conCategory = [...new Set(category)].join(",") || "-";
      }
    }
    // data.conTotalThai = '-'
    // data.conInsuranceBill = '-'
    if (customer) {
      data.cusTitle = customer.title || ""
      if (customer.type == "company") {
        data.cusType = i18n.t('project.business_type_company')
        data.cusFName = customer.companyName || ""
        data.cusLName = ""
      } else {
        data.cusType = i18n.t('project.business_type_personal')
        data.cusFName = customer.firstName || ""
        data.cusLName = customer.lastName || ""
      }
      data.cusAge = customer.dateOfBirth
        ? moment().diff(moment(customer.dateOfBirth), 'years')
        : ""
      data.cusCitizenId = customer.citizenId || ""
      data.cusCardExpDate = customer.citizenCardExpiryDate ? moment(customer.citizenCardExpiryDate).format('D MMMM ') + (moment(customer.citizenCardExpiryDate).year() + 543) : ""
      data.cusCardIssueDate = customer.citizenCardIssueDate ? moment(customer.citizenCardIssueDate).format('D MMMM ') + (moment(customer.citizenCardIssueDate).year() + 543) : ""
      data.cusAddress = `${customer.addressStreet || ''} ${customer.addressProvince == 'กรุงเทพมหานคร' ? "แขวง"
        : Helper.addressPrefix.subDistrict}${customer.addressSubDistrict || ''} ${customer.addressProvince == 'กรุงเทพมหานคร' ? "เขต"
          : Helper.addressPrefix.district}${customer.addressDistrict || ''} ${customer.addressProvince == 'กรุงเทพมหานคร' ? ""
            : Helper.addressPrefix.province}${customer.addressProvince || ''} ${customer.addressZipcode || ''}`;

      data.cusTel = Helper.telToString(customer.interTels, customer.tels) || "-"
      data.cusBanks = customer.bankAccounts
        ? customer.bankAccounts
          .map((d, i) => { return `(${i + 1}) ${i18n.t('payment.bank_account')} ${d.accountName} ${i18n.t('payment.account_number')} ${d.accountNumber}` })
          .join(",")
        : ""
      data.cusProfileImg = customer.profileImages && customer.profileImages.length ? customer.profileImages[0].url : ""
      data.cusCitizenCardImg = customer.citizenCardImages && customer.citizenCardImages.length ? customer.citizenCardImages[0].url : ""

      data.cusEName = customer.emergencyContactName || ""
      data.cusETel = customer.emergencyContactTel || ""
      data.cusERelation = customer.emergencyContactRelation || ""
      data.cusEEmail = customer.emergencyContactEmail || ""
      data.cusFacebook = customer.facebook || ""
      data.cusLine = customer.lineId || ""
      data.cusInstagram = customer.instagram || ""
      data.cusYoutube = customer.youtube || ""
      data.cusTiktok = customer.tiktok || ""
    }

    let hashbillingSetting = {}

    if (billingSettings && billingSettings.length) {
      for (let billingSetting of billingSettings) {
        let area = billingSetting.area
        let accountingProduct = billingSetting.accountingProduct
        if (!hashbillingSetting[area.objectId]) hashbillingSetting[area.objectId] = {}
        if (!hashbillingSetting[area.objectId][accountingProduct.objectId]) {
          hashbillingSetting[area.objectId][accountingProduct.objectId] = billingSetting.cost || 0
        }
      }
    }

    if (areaAccountingProducts && areaAccountingProducts.length) {
      for (let areaAccountingProduct of areaAccountingProducts) {
        let area = areaAccountingProduct.area
        let accountingProduct = areaAccountingProduct.accountingProduct
        if (!hashbillingSetting[area.objectId]) hashbillingSetting[area.objectId] = {}
        if (!hashbillingSetting[area.objectId][accountingProduct.objectId]) {
          hashbillingSetting[area.objectId][accountingProduct.objectId] = areaAccountingProduct.cost || 0
        }
      }
    }

    let rentalData = {}
    for (let areaId in hashbillingSetting) {
      for (let productId in hashbillingSetting[areaId]) {
        if (!rentalData[productId]) rentalData[productId] = 0
        rentalData[productId] += hashbillingSetting[areaId][productId]
      }
    }

    for (let key in rentalData) {
      data[`rm_${key}`] = Helper.toCurrency(rentalData[key])
      data[`ra_${key}`] = Helper.toCurrency(rentalData[key] * data.conLenNum)
      data[`rmt_${key}`] = Helper.numberToText(parseFloat(rentalData[key]))
      data[`rat_${key}`] = Helper.numberToText(parseFloat(rentalData[key] * data.conLenNum))
    }

    if (contractSuspend) {
      data.spdIssueDate = contractSuspend.issueDate && contractSuspend.issueDate.iso ? moment(contractSuspend.issueDate.iso).format('D MMMM ') + (moment(contractSuspend.issueDate.iso).year() + 543) : ""
      data.spdStartDate = contractSuspend.isSuspend && contractSuspend.startDate && contractSuspend.startDate.iso ? moment(contractSuspend.startDate.iso).format('D MMMM ') + (moment(contractSuspend.startDate.iso).year() + 543) : ""
      data.spdEndDate = contractSuspend.isSuspend && contractSuspend.endDate && contractSuspend.endDate.iso ? moment(contractSuspend.endDate.iso).format('D MMMM ') + (moment(contractSuspend.endDate.iso).year() + 543) : ""
      data.spdSuspend = contractSuspend.isSuspend ? i18n.t('yes') : i18n.t('not_yes')
      data.spdDetail = contractSuspend.detail || ""
      data.spdPenaltyDetail = contractSuspend.penaltyDetail || ""
      data.spdNote = contractSuspend.note || ""
      data.note = contractSuspend.note || ""
      data.spdType = ""
      data.spdType = i18n.t(`suspend.type.${contractSuspend.type}`) || ""
      if (contractSuspend.type == "other") {
        data.spdType = `${i18n.t('suspend.type.other')}${contractSuspend.otherType ? ' [' + contractSuspend.otherType + ']' : ''}`
      }
    }

    if (areaInterest) {
      data.aiCusNew = i18n.t('market.old_customer')
      if (!areaInterest.customer) {
        data.aiCusNew = i18n.t('market.new_customer')
        data.cusTitle = areaInterest.customerTitle || ""
        if (areaInterest.customerType == "company") {
          data.cusType = i18n.t('project.business_type_company')
          data.cusFName = areaInterest.customerCompanyName || ""
          data.cusLName = ""
        } else {
          data.cusType = i18n.t('project.business_type_personal')
          data.cusFName = areaInterest.customerFirstName || ""
          data.cusLName = areaInterest.customerLastName || ""
        }
        data.cusCitizenId = areaInterest.customerCitizenId || ""
        data.cusTel = areaInterest.customerTel || ""
      }
      data.aiSFullDate = areaInterest.contractStartDate && areaInterest.contractStartDate.iso
        ? moment(areaInterest.contractStartDate.iso).format("D MMMM ") + (moment(areaInterest.contractStartDate.iso).year() + 543)
        : ""
      data.aiEFullDate = areaInterest.contractEndDate && areaInterest.contractEndDate.iso
        ? moment(areaInterest.contractEndDate.iso).format("D MMMM ") + (moment(areaInterest.contractEndDate.iso).year() + 543)
        : ""
      data.aiConType = areaInterest.stallType == "regularly" ? i18n.t('contact.stall_type.regularly') : areaInterest.stallType == "temporary" ? i18n.t('contact.stall_type.temporary') : ""
      data.conType = areaInterest.stallType == "regularly" ? i18n.t('contact.stall_type.regularly') : areaInterest.stallType == "temporary" ? i18n.t('contact.stall_type.temporary') : ""
      data.aiAreasQty = areaInterest.areasQty
      data.aiAreas = areaInterest.areas ? areaInterest.areas.map(d => d.name).join(",") : ""
      data.aiProducts = areaInterest.products ? areaInterest.products.map(d => d.name).join(",") : ""
      data.aiNote = areaInterest.note || ""
      data.note = areaInterest.note || ""

      data.conSFullDate = areaInterest.contractStartDate && areaInterest.contractStartDate.iso
        ? moment(areaInterest.contractStartDate.iso).format("D MMMM ") + (moment(areaInterest.contractStartDate.iso).year() + 543)
        : ""
      data.conEFullDate = areaInterest.contractEndDate && areaInterest.contractEndDate.iso
        ? moment(areaInterest.contractEndDate.iso).format("D MMMM ") + (moment(areaInterest.contractEndDate.iso).year() + 543)
        : ""
      data.conLenNum = areaInterest.contractStartDate && areaInterest.contractStartDate.iso && areaInterest.contractEndDate && areaInterest.contractEndDate.iso
        ? moment(areaInterest.contractEndDate.iso).diff(areaInterest.contractStartDate.iso, 'months')
        : ""
      data.conLenNumText = Helper.numberToText(data.conLenNum)
      data.conLenDNum = areaInterest.contractStartDate && areaInterest.contractStartDate.iso && areaInterest.contractEndDate && areaInterest.contractEndDate.iso
        ? Math.round(moment(areaInterest.contractEndDate.iso).diff(areaInterest.contractStartDate.iso, 'days', true))
        : ""
      data.conLenDNumText = Helper.numberToText(data.conLenDNum)

      data.conLenYNum = areaInterest.contractStartDate && areaInterest.contractStartDate.iso && areaInterest.contractEndDate && areaInterest.contractEndDate.iso
        ? Helper.dayMonthYearText(areaInterest.contractStartDate.iso, areaInterest.contractEndDate.iso)
        : ""

      if (areaInterest.areas && areaInterest.areas.length) {
        let areas = areaInterest.areas
        data.conAreaSize = areas.reduce((a, b) => a + (b.size || 0), 0)
        data.conAreaSizeText = Helper.numberToText(data.conAreaSize)
        data.conAreas = areas.map(d => d.name).join(",")
        data.conAreaLen = areas.length
        data.conAreaLenText = Helper.numberToText(data.conAreaLen)
      }

      let products = []
      let category = []
      if (areaInterest.products && areaInterest.products.length) {
        for (let product of areaInterest.products) {
          products.push(product.name)
          if (product.productCategory) {
            category.push(product.productCategory.name)
          }
        }
      }
      data.conProducts = [...new Set(products)].join(",") || "-";
      data.conCategory = [...new Set(category)].join(",") || "-";
    }

    if (contractCheckout) {
      data.outDate = contractCheckout.checkOutDate
        ? moment(contractCheckout.checkOutDate).format("D MMMM ") + (moment(contractCheckout.checkOutDate).year() + 543)
        : ""
      data.outPayDate = contractCheckout.payDate
        ? moment(contractCheckout.payDate).format("D MMMM ") + (moment(contractCheckout.payDate).year() + 543)
        : ""
      data.outReceivedBy = contractCheckout.getReceivedBy || ""
      data.outTotal = contractCheckout.totalCost > 0 ? i18n.t('payment.refund_customer_money') : contractCheckout.totalCost < 0 ? i18n.t('payment.collect_customer_money') : i18n.t('payment.no_expense')
      if (contractCheckout.totalCost) {
        data.outTotal += " " + Helper.toCurrency(contractCheckout.totalCostAbs)
      }
      data.outAreas = contractCheckout.areas ? contractCheckout.areas.map(d => d.name).join(",") : ""
      data.note = contractCheckout.note || ""
    }
    return data
  }
  static prepareHtmlContent(html, contractTemplateData) {
    let data = contractTemplateData || {}
    if (data["cusProfileImg"]) html = html.replaceAll("/images/myket-example-profile.png", data["cusProfileImg"])
    if (data["cusCitizenCardImg"]) html = html.replaceAll("/images/myket-example-citizen-card.png", data["cusCitizenCardImg"])
    let chunks = html.split(/({{[A-Za-z0-9_.]+}})/g);
    let chunksTranslated = chunks.map(function (chunk) {
      if (chunk.slice(0, 2) === "{{" && chunk.slice(-2) === "}}" && (data[chunk.slice(2, -2)] || data[chunk.slice(2, -2)] == 0)) {
        let key = chunk.slice(2, -2)
        return data[key]
      }
      return chunk
    });
    return chunksTranslated.join("")
  }
}